import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, SimpleChanges, TemplateRef } from '@angular/core';
import { FilterModel, IFilterModel } from '../split-button-filter/split-button-filter.component';
import { ButtonFilterService } from '../../services/button-filter.service';

@Component({
  selector: 'split-table-calendar',
  templateUrl: './split-table-calendar.component.html',
  styleUrls: ['./split-table-calendar.component.css']
})
export class SplitTableCalendarComponent {
  @ContentChildren('coluna') colunas!: QueryList<TemplateRef<any>>;
  @ContentChildren('header') headers!: QueryList<TemplateRef<any>>;
  @ContentChildren('linha') linhas!: QueryList<TemplateRef<any>>;

  @Input() dados: Array<any> = [];
  @Input() theme: String = "primary";
  @Input() checklist: boolean = false;

  @Input() widthColumns: Array<number> = [];

  public computedData: Array<any> | null = null;

  @Input() filters: Array<FilterModel> = [];

  @Input() loading = false;


  filterArray: Array<FilterModel> = [];


  first: number = 0;
  @Input() rows: number = 10;
  @Input() totalRecords: number = 0;
  @Input() paginator = false;
  @Output() pageChange = new EventEmitter();

  constructor(private buttonFilterService: ButtonFilterService) {
  
  }


  onPageChange(event: PageEvent | any) {
    this.first = event.first;
    this.rows = event.rows;
    
    event.page = event.page + 1;
    this.pageChange.emit(event);
}


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['filters']) {
      console.log(this.filters)
    }
  }

  ngOnInit(): void {
    if (this.checklist) {
      this.dados = this.dados.map((dado) => {
        return { ...dado, checklist: false };
      });
    }
  }

  checkAll(ev: any) {
    this.dados.forEach(x => x.checklist = ev.checked)
  }

  isAllChecked() {
    return this.dados.every((_) => _.checklist);
  }

  remove(filter: IFilterModel, position: number | null = null) {
    this.buttonFilterService.remove(filter, position);
  }

  clearFilter() {
    this.buttonFilterService.clear();
  }
}

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
